module.exports = __webpack_public_path__ + "static/img/template.aa891642.svg";